export default class Enums {
  constructor(obj) {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
      this[obj[key]] = key;
    });
  }
  map(keys) {
    return keys.map(x => this[x]);
  }
  has(key) {
    return this.hasOwnProperty(key)
  }
}
